import { PartnerPlatform } from './PartnerPlatform';
import { PartnerPlatformSyncJobStatus } from './PartnerPlatformSyncJobStatus';

export interface PartnerPlatformSyncJob {
  id: number;
  partnerPlatform: PartnerPlatform;
  status: PartnerPlatformSyncJobStatus;
  totalCount: number;
  processedCount: number;
  createdAt: Date;
  startedAt?: Date;
  finishedAt?: Date;
}

export const partnerPlatformSyncJobFromResponse = (
  responseData: any,
): PartnerPlatformSyncJob => ({
  id: responseData.id,
  partnerPlatform: responseData.partner_platform,
  status: responseData.status,
  totalCount: responseData.total_count,
  processedCount: responseData.processed_count,
  createdAt: new Date(responseData.created_at),
  startedAt: responseData.started_at
    ? new Date(responseData.started_at)
    : undefined,
  finishedAt: responseData.finished_at
    ? new Date(responseData.finished_at)
    : undefined,
});
